import * as React from 'react';
// import { Redirect } from 'react-router-dom';
// import { NotFoundComponent } from '@common/components';
import { Emoji } from '../emoji';
// import { Link } from 'react-router-dom';
import { history } from 'src';
import { logService } from '@services/LogService';

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<{}, ErrorBoundaryState> {
  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: any, errorInfo: { componentStack: string }) {
    logService.logError(error.toString(), errorInfo.componentStack.toString());

    // console.error('You got an error in the frontend of the application. Please correct it.');
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="row middle-xs center-xs" style={{ minHeight: '60vh' }}>
          <h2>
            <strong>Oops! Something went wrong!</strong>
          </h2>
          <h3>
            A severe error has occurred in the application. A record of this has been logged and will be fixed in a
            future software release.
          </h3>
          <div className="col-xs-12 mt-10 pt-10 mb-10 pb-10">
            <Emoji name={Emoji.EmojiNames.SeeNoEvil} size={window.innerWidth / 4 > 200 ? 200 : window.innerWidth / 4} />
          </div>
          <div className="col-xs-12 mt-10 pt-10">
            <button className="btn btn-secondary" onClick={() => window.history.back()}>
              Go Back
            </button>
            <button onClick={() => history.push('/dashboard')} className="btn btn-primary">
              Go to the Dashboard
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./src/common/components/error-boundary/error-boundary.tsx